import { render, staticRenderFns } from "./AboutEESTEC.vue?vue&type=template&id=4d0ff676&scoped=true&"
import script from "./AboutEESTEC.vue?vue&type=script&lang=js&"
export * from "./AboutEESTEC.vue?vue&type=script&lang=js&"
import style0 from "./AboutEESTEC.vue?vue&type=style&index=0&id=4d0ff676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ff676",
  null
  
)

export default component.exports